import styled from 'styled-components';
import { shade } from 'polished';

export const Container = styled.button`
  background-color: #846dd2;
  color: #f8f7f7;
  border-radius: 10px;
  border: 0;
  width: 100%;
  height: 56px;
  font-weight: 500;
  margin-top: 24px;
  transition: background-color 0.2s;
  &:hover {
    background-color: ${shade(0.2, '#846DD2')};
  }
`;
